import api from '../api';

function initialState() {
  return {
    notifications: [],
    error: {},
  };
}

export default {
  namespaced: true,

  state: initialState,

  getters: {
    unread: state => state.notifications.filter(notify => notify.status === 'unread'),
    read: state => state.notifications.filter(notify => notify.status !== 'unread'),
  },

  mutations: {
    SET_NOTIFICATIONS(state, payload) {
      state.notifications = payload;
    },
    SET_ERROR(state, payload) {
      state.error = payload;
    },
  },

  actions: {
    /**
     * Get a list of notifications for the current user
     */
    async list({ commit, state }, forceUpdate = false) {
      let resp;
      let payload;

      const timediff = 600; // 10 minutes

      const localNotifications = localStorage.getItem('mft_userNotifications_list');

      if (
        !localNotifications ||
        forceUpdate ||
        JSON.parse(localNotifications).timestamp < (new Date().getTime() - timediff)
        ) {

        try {
          resp = await api().put('/currentuser/notifications/flat', {
            filter: {
              sort: {
                created_time: 'desc',
              },
            },
          });

          payload = {
            notifications: resp.data.data.notification,
            timestamp: new Date().getTime(),
          };
          try {
            localStorage.setItem('mft_userNotifications_list', JSON.stringify(payload));
          } catch (err) {
          }
        } catch (error) {
          if (
            error.response.data.data.length === 0 &&
            error.response.data.error.status_code === 404
          ) {
            commit('SET_NOTIFICATIONS', []);
            return Promise.resolve([]);
          }
          commit('SET_ERROR', error);
          return Promise.reject(error);
        }
      } else {
        payload = JSON.parse(localNotifications);
      }

      commit('SET_NOTIFICATIONS', payload.notifications);
      return Promise.resolve(payload.notifications);
    },
    async read({ dispatch }, notificationSelf) {
      let response;

      try {
        response = await api().post(`/${notificationSelf}/read`);
        dispatch('list');
        return Promise.resolve(response.data.data.notification);
      } catch (err) {
        return Promise.reject(err);
      }
    },

    async markAllAsRead({ dispatch, state }) {
      // hopefully this is just temporary
      const unread = state.notifications.filter(notification => notification.status === 'unread');

      await Promise.all(unread.map(async (notify) => {
        await dispatch('read', notify.self);
      }));
      // need to clear local storage
      localStorage.removeItem('mft_userNotifications_list')
      dispatch('list')

      return Promise.resolve();
    },

    async delete({ dispatch }, notificationSelf) {
      let response;

      try {
        response = await api().delete(`/${notificationSelf}`);
        dispatch('list');
        return Promise.resolve(response.data.data.notification);
      } catch (err) {
        return Promise.reject(err);
      }
    },

    readAllNotifications({ state }) {
      // TODO
    },
  },
};
